import PropTypes from "prop-types";
import React, { useRef } from "react";

const SkInput = ({ onFileSelect }) => {
  const fileInput = useRef(null);

  const handleFileInput = (e) => {
    // handle validations
    onFileSelect(e.target.files[0]);
  };
  return (
    <div className="file-uploader">
      <input type="file" onChange={handleFileInput} />
      <button
        onClick={(e) => fileInput.current && fileInput.current.click()}
        className="btn btn-primary"
      />
    </div>
  );
};

export default SkInput;
SkInput.propTypes = {
  onFileSelect: PropTypes.any,
};
